export const RESTART_ON_REMOUNT = '@@saga-injector/restart-on-remount';
export const DAEMON = '@@saga-injector/daemon';
export const ONCE_TILL_UNMOUNT = '@@saga-injector/once-till-unmount';
export const API_PATH = '/api/v1';
export const SEARCH_PATH = '/graphql';
export const APP_MAX_TABLET_WIDTH = 850;
export const APP_MAX_MOBILE_WIDTH = 416;
export const TABLET_PADDING_LR = '55px';
export const MOBILE_PADDING_LR = '28px';
